module.exports = __webpack_public_path__ + "img/interview-logo-register-page.9c4fcb8d.png";